<nav
  class="navbar navbar-dark navbar-expand-lg d-none d-lg-flex"
  [ngClass]="isCorporate ? 'bg-primary-corporate navbar-corporate' : 'bg-primary navbar-default'"
>
  <a class="navbar-brand py-0" [routerLink]="['/']" routerLinkActive="router-link-active">
    <ng-container *ngIf="!isCorporate && !isJuniorBluebirds"
      ><img class="ms-2 h-100" [src]="'logos/logo.svg' | contentAssetImage" draggable="false"
    /></ng-container>
    <ng-container *ngIf="isCorporate"
      ><img class="ms-2 h-100" [src]="'logos/corporate-logo.png' | contentAssetImage" draggable="false"
    /></ng-container>
    <ng-container *ngIf="isJuniorBluebirds"
      ><img class="ms-2 h-100" [src]="'logos/kid-logo.png' | contentAssetImage" draggable="false"
    /></ng-container>
  </a>

  <button
    class="navbar-toggler"
    type="button"
    (click)="isCollapsed = !isCollapsed"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- Left Side Content -->
  <div class="navbar-collapse" [ngbCollapse]="isCollapsed" id="navbarSupportedContent">
    <div class="nav-container">
      <ul class="navbar-nav me-auto" #greedyNav>
        <li class="nav-item active">
          <a class="nav-link mx-1" [routerLink]="['/rewards']" routerLinkActive="router-link-active">{{
            'navbar.rewards' | translate
          }}</a>
        </li>
        <li class="nav-item active">
          <a class="nav-link mx-1" [routerLink]="['/challenges']" routerLinkActive="router-link-active">{{
            'navbar.challenges' | translate
          }}</a>
        </li>
        <li class="nav-item active">
          <a class="nav-link mx-1" [routerLink]="['/games']" routerLinkActive="router-link-active">{{
            'navbar.games' | translate
          }}</a>
        </li>
        <li class="nav-item active" *notInPopulation="[populations.JuniorBluebirds]">
          <a class="nav-link mx-1" [routerLink]="['/earn']" routerLinkActive="router-link-active">{{
            'navbar.earnpoints' | translate
          }}</a>
        </li>
        <li class="nav-item active">
          <a class="nav-link mx-1" [routerLink]="['/gallery']" routerLinkActive="router-link-active">{{
            'navbar.gallery' | translate
          }}</a>
        </li>
        <li class="nav-item active" *inPopulation="[populations.JuniorBluebirds]">
          <a class="nav-link mx-1" [routerLink]="['/worksheet']" routerLinkActive="router-link-active">{{
            'navbar.activities' | translate
          }}</a>
        </li>
      </ul>
    </div>
    <!-- Right Side Content -->
    <div class="d-flex align-items-center flex-nowrap my-2 my-lg-0">
      <div class="balance font-size-14 text-white" *notInPopulation="[populations.JuniorBluebirds]">
        <div class="d-flex align-items-center justify-content-center bg-glass" *ngIf="loyaltyPointsCard$">
          <span class="icon material-symbols-outlined currency-icons pe-1">loyalty</span>
          <span class="ps-1 fw-bold">{{ loyaltyPointsCard$ | async | FortressCurrencyPipe: 'PTS' }}</span>
        </div>
      </div>
      <fgb-notification-button></fgb-notification-button>

      <!-- side nav -->
      <button
        class="nav-link btn d-flex align-items-center mx-2 px-0 justify-content-end"
        (click)="isNavOpen = !isNavOpen"
        id="namedropdown"
        attr.aria-label="{{ 'nav.account.menu.screenreader' | translate }}"
        tabindex="-1"
        focusTab
      >
        <i class="material-symbols-outlined text-white right-nav-menu-btn">dehaze</i>
      </button>
    </div>
  </div>
</nav>

<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4">
    <fgb-loading [size]="'small'"></fgb-loading>
  </div>
</ng-template>

<div class="right-nav-menu-overlay" *ngIf="isNavOpen" [@rightMenuOverlayAnimation]></div>
<div
  class="right-nav-menu"
  [@rightNavAnimation]="isNavOpen ? 'open' : 'close'"
  [ngClass]="{ open: isNavOpen, 'bg-primary-corporate': isCorporate, 'bg-white': !isCorporate }"
>
  <!--Logo-->
  <ng-container *ngIf="!isCorporate && !isJuniorBluebirds"
    ><img class="brand" [src]="'logos/logo.svg' | contentAssetImage" draggable="false"
  /></ng-container>
  <ng-container *ngIf="isCorporate"
    ><img class="brand" [src]="'logos/corporate-logo.png' | contentAssetImage" draggable="false"
  /></ng-container>
  <ng-container *ngIf="isJuniorBluebirds"
    ><img class="kids-brand" [src]="'logos/kid-logo.png' | contentAssetImage" draggable="false"
  /></ng-container>

  <!-- Close Button -->
  <button
    type="button"
    class="btn close-button position-absolute pe-0"
    [ngClass]="isCorporate ? 'text-white' : 'text-info'"
    (click)="isNavOpen = false"
  >
    <span class="material-symbols-outlined">close</span>
  </button>

  <div class="d-flex flex-column position-relative h-100">
    <div class="member-card-container mb-3">
      <fgb-member-card [isNavSideMenu]="true"></fgb-member-card>
    </div>

    <div class="right-nav-menu-list" [ngClass]="{ 'nav-corporate-list': isCorporate }">
      <!-- Nav Buttons -->

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/account']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="material-symbols-outlined"> account_circle </span>
        <span class="nav-text">{{ 'nav.profile' | translate }}</span>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/rewards/wallet']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="nav-item-title-div">
          <fgbcl-wallet-text-with-badge [count]="unredeemedCount">
            <span class="material-symbols-outlined"> account_balance_wallet </span>
            <span class="nav-text wallet-text">{{ 'nav.wallet' | translate }}</span>
          </fgbcl-wallet-text-with-badge>
        </div>
      </a>

      <div class="help-wrapper">
        <div class="right-nav-menu-item help-dropdown" (click)="toggleMenu()">
          <span class="material-symbols-outlined">info</span>
          <span class="nav-text">{{ 'nav.help' | translate }}</span>
          <span class="material-symbols-outlined arrow" [ngClass]="{ open: isMenuOpen }">expand_more</span>
        </div>

        @if (isMenuOpen) {
          <div class="help-submenu">
            <a class="right-nav-sub-item fw-bold" data-bs-dismiss="offcanvas" [routerLink]="['/terms']">
              {{ 'nav.terms' | translate }}
            </a>
            <a class="right-nav-sub-item fw-bold" data-bs-dismiss="offcanvas" [routerLink]="['/faq']">
              {{ 'nav.faq' | translate }}
            </a>
            <a class="right-nav-sub-item fw-bold" data-bs-dismiss="offcanvas" [routerLink]="['/contact']">
              {{ 'nav.contact.us' | translate }}
            </a>
          </div>
        }
      </div>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        href="{{ 'nav.cardiff.official.url' | translate }}"
        target="_blank"
      >
        <span class="material-symbols-outlined"> captive_portal </span>
        <span class="nav-text">{{ 'nav.cardiff.official' | translate }}</span>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        href="{{ 'nav.cardiff.superstore.url' | translate }}"
        target="_blank"
      >
        <span class="material-symbols-outlined"> storefront </span>
        <span class="nav-text">{{ 'nav.cardiff.superstore' | translate }}</span>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        href="{{ 'nav.cardiff.city.tv.url' | translate }}"
        target="_blank"
      >
        <span class="material-symbols-outlined"> live_tv </span>
        <span class="nav-text">{{ 'nav.cardiff.city.tv' | translate }}</span>
      </a>

      <a
        class="log-out py-1 position-absolute bottom-0 w-100"
        data-bs-dismiss="offcanvas"
        [ngClass]="{ 'corporate-logout-item': isCorporate || isJuniorBluebirds }"
        (click)="logout()"
      >
        <i class="material-symbols-outlined">logout</i>
        <div class="nav-text font-size-14 fw-bold">{{ 'nav.log.out' | translate }}</div>
      </a>
    </div>
  </div>
</div>
